import React from 'react';
import PropTypes from 'prop-types';


export class Group extends React.Component {

  static propTypes = {
    backgroundColor: PropTypes.string,
    group: PropTypes.string,
    itemType: PropTypes.string,
    listType: PropTypes.string
  };

  static defaultProps = {
    backgroundColor: "#fff",
    group: "group",
    itemType: "plainItem",
    listType: "plainList"
  };

  render() {
    let children = undefined;

    if (this.props.children) {
      if (typeof this.props.children.map === 'function') {
        children = this.props.children.map((child, i) => {
          return (
            <li className={`item ${this.props.itemType}`} key={i}>{child}</li>
          );
        });
      } else {
        children = <li className="item">{this.props.children}</li>;
      }
    }

    return (
      <div className={this.props.group}
           style={{backgroundColor: this.props.backgroundColor}}>
        {this.props.title && <div className="title">{this.props.title}</div>}
        <ul className={this.props.listType}>{children}</ul>
      </div>
    );
  }
}
